import React from "react";
import "./loadingScreen.css";
import { usePromiseTracker } from "react-promise-tracker";




// export default function loadingScreen() {
//   const { promiseInProgress } = usePromiseTracker();


//   return (
//     promiseInProgress &&
//     <div className={'wholepage'}>
// <div class="loader"></div>
//     </div>
//   );
// }

const LoadingScreen = props => {
  const { promiseInProgress } = usePromiseTracker();

  return promiseInProgress && 
     <div className={'wholepage'}>
<div class="myloader"></div>
    </div>
};

export default LoadingScreen